export * from './config.js';
export * from './types.js';
export * from './did.js';
export * from './wallet.js';
import { DID } from './did.js';
export const did = new DID();
